import React from 'react';

import { ViewPropTypes } from 'deprecated-react-native-prop-types';
import { isEmpty as _isEmpty } from 'lodash';
import PropTypes from 'prop-types';

import { colorPropType } from '../../../Utils/PropTypesValidators';
import VFInput from '../../VFInput';

import styles from './SearchInput.Styles';

function SearchInput({
  getLayout,
  open,
  close,
  label,
  labelStyle,
  labelFontSize,
  isArrowShown,
  labelProps,
  arrowIcon,
  arrowStyle,
  style,
  searchInput,
  handleSearchInputFocus,
  handleSearchInput,
  forwardedRef,
  isSearchable,
  cursorColor,
  textColor,
  borderColor,
  activeBorderColor,
  searchInputFontSize,
}) {
  return (
    <VFInput
      label={label}
      labelProps={labelProps}
      labelTextStyle={labelStyle}
      labelFontSize={labelFontSize}
      value={searchInput}
      onChangeText={value => handleSearchInput(value)}
      baseColor={borderColor}
      tintColor={activeBorderColor}
      selectionColor={cursorColor}
      textColor={textColor}
      onFocus={open}
      onBlur={close}
      showRightIcon={isArrowShown ? true : false}
      rightIconPress={handleSearchInputFocus}
      rightIconName={arrowIcon}
      rightIconStyle={arrowStyle}
      ref={forwardedRef}
      onLayout={event => getLayout(event.nativeEvent.layout)}
      containerStyle={[styles.inputContainerStyle, style]}
      isSearchable={isSearchable}
      isSearchItemExist={!_isEmpty(searchInput) ? true : false}
      fontSize={searchInputFontSize}
    />
  );
}

SearchInput.propTypes = {
  getLayout: PropTypes.func,
  label: PropTypes.string,
  labelStyle: ViewPropTypes.style,
  labelProps: PropTypes.object,
  isArrowShown: PropTypes.bool,
  arrowIcon: PropTypes.string,
  arrowStyle: ViewPropTypes.style,
  style: ViewPropTypes.style,
  open: PropTypes.func,
  close: PropTypes.func,
  searchInput: PropTypes.string,
  handleSearchInputFocus: PropTypes.func,
  handleSearchInput: PropTypes.func,
  forwardedRef: PropTypes.object,
  isSearchable: PropTypes.bool,
  cursorColor: colorPropType,
  textColor: colorPropType,
  borderColor: colorPropType,
  activeBorderColor: colorPropType,
  labelFontSize: PropTypes.number,
  searchInputFontSize: PropTypes.number,
};

export default SearchInput;
